export type CommunitySectionGroup = 'General' | 'Gestión' | 'Comunicación' | 'Administración';

export type CommunitySection = {
  id: string;
  label: string;
  route: string;
  group: CommunitySectionGroup;
};

export const COMMUNITY_SECTIONS: CommunitySection[] = [
  { id: 'dashboard', label: 'Dashboard', route: '/app', group: 'General' },
  { id: 'community', label: 'Comunidad', route: '/app/communities', group: 'General' },
  { id: 'calendar', label: 'Calendario', route: '/app/calendar', group: 'General' },
  { id: 'payments', label: 'Pagos y Cuotas', route: '/app/payments', group: 'Gestión' },
  { id: 'incidents', label: 'Incidencias', route: '/app/incidents', group: 'Gestión' },
  { id: 'meetings', label: 'Juntas y Acuerdos', route: '/app/meetings', group: 'Gestión' },
  { id: 'documents', label: 'Documentación', route: '/app/documents', group: 'Gestión' },
  { id: 'reservations', label: 'Reservas', route: '/app/reservations', group: 'Gestión' },
  { id: 'providers', label: 'Proveedores', route: '/app/providers', group: 'Gestión' },
  { id: 'suggestions', label: 'Sugerencias y Propuestas', route: '/app/suggestions', group: 'Comunicación' },
  { id: 'announcements', label: 'Tablón de Anuncios', route: '/app/announcements', group: 'Comunicación' },
  { id: 'quick-polls', label: 'Encuestas Rápidas', route: '/app/quick-polls', group: 'Comunicación' },
  { id: 'admin-communities', label: 'Comunidades (admin)', route: '/app/admin/communities', group: 'Administración' },
  { id: 'admin-campaigns', label: 'Campañas', route: '/app/admin/campaigns', group: 'Administración' },
  { id: 'admin-users', label: 'Usuarios', route: '/app/users', group: 'Administración' },
  { id: 'settings', label: 'Configuración', route: '/app/settings', group: 'Administración' },
];

const COMMUNITY_SECTION_ROUTES = COMMUNITY_SECTIONS.map(section => section.route);

export const normalizeCommunitySectionSelection = (selection?: string[] | null): string[] => {
  if (!selection || selection.length === 0) {
    return [];
  }

  const selectionSet = new Set(selection);
  return COMMUNITY_SECTION_ROUTES.filter(route => selectionSet.has(route));
};
